export enum Activist {
  All = 'All',
  Occasional = 'Occasional',
  Often = 'Often'
}
